<div class="video-container overflow-hidden video-wrapper position-relative m-auto w-100 rounded-3">
  <video #target playsinline webkit-playsinline id="my_video"
    class="video-js overflow-hidden vjs-default-skin vjs-big-play-centered rounded-3" controls preload="auto"
    [attr.disablePictureInPicture]="true" (play)="onPlayListener()" (pause)="onPauseListener()"></video>

  <!-- <div class="overlay-controls position-absolute d-flex">
    <button (click)="seek(-10)">⏪ 10s</button>
    <button (click)="seek(10)">⏩ 10s</button>
  </div> -->
</div>